export const insuranceTabTrackingIds = {
  enhancedEligibilityRefreshButton: 'insurance-tab:enhanced-eligibility-refresh-button',
  verifyInsuranceButton: 'insurance-tab:verify-insurance-button',
  viewReportButton: 'insurance-tab:view-report-button',
  verifyManuallyButton: 'insurance-tab:verify-manually-button',
  actionMenuButton: 'insurance-tab:action-menu-button',
  actionMenuViewReportButton: 'insurance-tab:action-menu:view-report-button',
  actionMenuVerifyInsuranceButton: 'insurance-tab:action-menu:verify-insurance-button',
  actionMenuVerificationMetricButton: 'insurance-tab:action-menu:verification-metric-button',
  actionMenuWriteBackStatusButton: 'insurance-tab:action-menu:writeback-status-button',
  actionMenuOverrideInsuranceStatusButton: 'insurance-tab:action-menu:override-insurance-status-button',
  viewInsuranceReportPostVerificationButton: 'insurance-tab:view-insurance-report-post-verification-button',
};

export const writebackModalTrackingIds = {
  insurancePlanDropdown: 'writeback-modal:insurance-plan-dropdown',
  refetchInsurancePlansButton: 'writeback-modal:refetch-insurance-plans-button',
  writebackModalUpdateButton: 'writeback-modal:update-button',
  writebackModalCloseButton: 'writeback-modal:close-button',
  closeWritebackModalContainerButton: 'writeback-modal:close-writeback-modal-container-button',
};

export const verificationMetricsModalTrackingIds = {
  closeVerificationMetricsModalButton: 'verification-metrics-modal:close-verification-metrics-modal-button',
  locationSelectorDropdownField: 'verification-metrics-modal:location-selector-dropdown-field',
  dateRangeSelectorDropdownField: 'verification-metrics-modal:date-range-selector-dropdown-field',
  customDateRangePickerField: 'verification-metrics-modal:custom-date-range-picker-field',
};

export const verifyInsuranceFormTrackingIds = {
  verifyButton: 'verify-insurance-form:verify-button',
  cancelButton: 'verify-insurance-form:cancel-button',
  payerNameDropdown: 'verify-insurance-form:insurance-payer-name-dropdown',
  planSearchInput: 'verify-insurance-form:plan-search-input',
  memberIdInput: 'verify-insurance-form:member-id-input',
  zipCodeInput: 'verify-insurance-form:zip-code-input',
  groupNumberInput: 'verify-insurance-form:group-number-input',
  groupNameInput: 'verify-insurance-form:group-name-input',
  dobInput: 'verify-insurance-form:dob-input',
  lastNameInput: 'verify-insurance-form:last-name-input',
  firstNameInput: 'verify-insurance-form:first-name-input',
  subscriberFirstNameInput: 'verify-insurance-form:subscriber-first-name-input',
  subscriberLastNameInput: 'verify-insurance-form:subscriber-last-name-input',
  subscriberDobInput: 'verify-insurance-form:subscriber-dob-input',
  subscriberMemberIdInput: 'verify-insurance-form:subscriber-member-id-input',
  subscriberZipCodeInput: 'verify-insurance-form:subscriber-zip-code-input',
  relationshipToSubscriberDropdown: 'verify-insurance-form:relationship-to-subscriber-dropdown',
  primarySubscriberDropdown: 'verify-insurance-form:primary-subscriber-dropdown',
  nationalProviderIdInput: 'verify-insurance-form:national-provider-id-input',
  taxIdInput: 'verify-insurance-form:tax-id-input',
};

export const insuranceStatusChipTrackingIds = {
  insuranceStatusChipContainer: 'insurance-status-chip:container',
  insuranceStatusChipTag: 'insurance-status-chip:tag',
};
